import React from 'react'
import { connect } from 'react-redux'

import DealerDetails from './DealerDetails'
import GenerateAnswer from './GenerateAnswer'
import UserDetails from './UserDetails'
import CarDetails from './CarDetails'

import {
    getThreadDetails,
    getDealershipDetails,
    getUserData,
    getSubscriptionStatus,
} from './actions'

import './index.scss'

class Details extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {}
    }

    componentDidMount() {
        const { historicalDialogue, historicalDialogueLoading } = this.props

        if (!historicalDialogueLoading && historicalDialogue) {
            this.getDetails()
        }
    }

    componentDidUpdate(oldProps) {
        if (JSON.stringify(oldProps) === JSON.stringify(this.props)) {
            return
        }

        const { historicalDialogue } = this.props

        const oldHistoricalDialogue = oldProps.historicalDialogue

        let shouldUpdate = false
        if (!oldHistoricalDialogue && historicalDialogue) {
            shouldUpdate = true
        }

        const defaultTemplate = { AccountId: '', UserId: '', ThreadId: '' }

        const oldFirstMessage = oldHistoricalDialogue?.[0] || defaultTemplate
        const firstMessage = historicalDialogue?.[0] || defaultTemplate

        if (
            oldFirstMessage.AccountId !== firstMessage.AccountId
            || oldFirstMessage.UserId !== firstMessage.UserId
            || oldFirstMessage.ConversationId !== firstMessage.ConversationId
        ) {
            shouldUpdate = true
        }

        if (oldProps.shouldRefetchSubs !== this.props.shouldRefetchSubs) {
            shouldUpdate = true
        }

        if (shouldUpdate) {
            this.getDetails()
        }
    }

    getDetails() {
        const { historicalDialogue } = this.props

        if (!historicalDialogue) {
            return
        }

        const [firstMessage] = this.props.historicalDialogue

        if (!firstMessage) {
            return
        }

        const {
            AccountId: accountId,
            ThreadId: threadId,
            UserId: userId,
            Email: email,
            Phone: phone,
        } = firstMessage

        let { ConversationId: convoId } = firstMessage

        if (!convoId) {
            convoId = `${accountId}/${userId}/${threadId}`
        }

        this.props.getThreadDetails(accountId, threadId)

        this.props.getUserData(accountId, userId, threadId, convoId)

        this.props.getSubscriptionStatus(accountId, { email, phone })

        this.props.getDealershipDetails(accountId)
    }

    render() {
        const { historicalDialogueLoading, historicalDialogue } = this.props

        return (
            <React.Fragment>
                {!historicalDialogueLoading && historicalDialogue && (
                    <div className='OperatorDialogueDetails'>
                        <GenerateAnswer />
                        <DealerDetails />
                        <UserDetails />
                        <CarDetails />
                    </div>
                )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    const { historicalDialogueLoading, historicalDialogue } = state.operatorDashboard

    const { shouldRefetchSubs } = state.operatorDashboardDetails

    return {
        historicalDialogueLoading,
        historicalDialogue,
        shouldRefetchSubs,
    }
}

export default connect(mapStateToProps, {
    getThreadDetails,
    getDealershipDetails,
    getUserData,
    getSubscriptionStatus,
})(Details)
